(function () {
'use strict';

(function(rum) {
    rum.logAjaxError = function (params, xhr, name, error) {
        params.type = 'network';
        params.additional = params.additional || {};

        if (name === 'timeout') {
            params.additional.timeout = 1;
        } else if (xhr.status) {
            params.additional.status = xhr.status;
        }

        rum.logError(params, error);
    };
})(Ya.Rum);

}());
